export default __webpack_public_path__ + "static/char-t-21-zh-Hans-e54067f480c21a7f36dd9313f9e656d4.png";